import { FC } from 'react';
import styled from 'styled-components';

const TopAreaElement = styled.div`
  position: relative;
  grid-area: toparea;
  z-index: 2;
`;

export const TopArea: FC = props => {
  return <TopAreaElement>{props.children}</TopAreaElement>;
};
